import React from 'react';

type OwnProps = {
    fill0?: string;
    fill1?: string;
};

// @ts-expect-error TS(2456): Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof AmnestyLogo.defaultProps;

// @ts-expect-error TS(7022): 'AmnestyLogo' implicitly has type 'any' because it... Remove this comment to see the full error message
const AmnestyLogo = ({ fill0, fill1, ...props }: Props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        width="7.86111in"
        height="3.125in"
        version="1.1"
        viewBox="0 0 7861 3125"
        {...props}
    >
        <g id="Layer_x0020_1">
            <metadata id="CorelCorpID_0Corel-Layer" />
            <polygon fill={fill0} points="0,3125 7874,3125 7874,-11 0,-11 " />
            <path
                fill={fill1}
                d="M6138 2194c-2,29 -31,31 -31,31 -27,0 -44,-52 -51,-51 -9,2 2,44 -9,51 -8,8 -188,-72 -202,-85 -12,-12 5,-28 0,-39 -3,-10 -31,-7 -39,-11 -7,-7 8,-36 -2,-43 -9,-5 -27,30 -39,13 -5,-7 -7,-18 -7,-33 0,-100 110,-141 185,-165 30,-10 20,28 30,29 12,3 14,-18 27,-18 10,0 49,18 58,11 7,-5 -20,-29 -12,-39 10,-8 90,-21 90,-7l0 355zm627 -1063c0,-28 -20,-49 -42,-49l-184 0c-51,0 -48,-36 -48,-44 0,-217 328,-254 328,-538 0,-124 -81,-208 -177,-281 -5,-3 0,18 0,26 0,132 -511,201 -511,507 0,267 275,278 275,319 0,8 -17,11 -19,11l-211 0c-22,0 -42,21 -42,49l0 164c-20,7 -46,-23 -59,-23 -7,0 -3,51 -15,57 -10,5 -202,70 -219,72 -27,5 -20,-41 -36,-41 -14,0 -14,46 -48,46 -20,0 -37,-18 -53,-18 -10,0 22,38 22,49 0,31 -63,42 -63,64 0,11 59,-5 68,-5 31,0 27,34 39,34 12,0 20,-39 31,-46 20,-12 44,8 54,8 17,0 -14,-39 2,-46 0,0 207,-85 221,-79 12,7 10,26 24,33 14,7 34,-46 34,-13l0 401c-24,15 -75,23 -102,23 -13,0 -7,-42 -15,-42 -14,0 -27,36 -47,36 -19,0 -46,-44 -65,-44 -12,0 22,56 2,65 -78,38 -202,74 -202,193 0,25 14,54 8,62 -5,12 -32,34 -31,44 0,10 51,6 61,21 5,8 8,44 19,44 8,0 30,-28 49,-18 59,34 163,72 211,97 12,6 5,43 12,46 14,7 41,-34 83,-11 9,3 17,16 17,31l0 132c0,25 12,31 25,34l506 100c0,0 37,6 53,6 19,0 36,-3 36,-39l2 -308c0,-3 2,-8 7,-8 32,0 27,83 34,83 13,0 22,-56 39,-56 24,0 39,21 49,16 8,-5 -5,-31 -5,-48 0,-15 44,-21 98,-41 48,-16 87,-34 102,-34 12,0 20,31 31,31 8,0 10,-41 29,-41 15,0 49,23 58,16 7,-5 -17,-36 2,-49 13,-8 46,-28 46,-36 0,-5 -63,-6 -66,-6 -12,-3 -25,-39 -34,-39 -10,0 -10,36 -25,48 -14,10 -47,-34 -63,-34 -9,0 10,33 10,59 0,26 -165,77 -187,77 -34,0 -36,-41 -43,-41 -10,0 -9,49 -51,49 -19,0 -24,-10 -24,-20l0 -392c0,-12 3,-29 25,-29 31,0 31,59 41,59 19,0 29,-61 65,-61 27,0 49,36 66,36 12,0 -20,-38 -20,-56 0,-18 168,-11 233,-121 19,-31 19,-69 26,-83 10,-16 47,-13 47,-25 0,-5 -27,-11 -37,-18 -20,-11 -13,-70 -24,-70 -15,0 -31,41 -46,23 -27,-33 -139,-95 -190,-113 -19,-7 13,-61 5,-65 -9,-5 -31,33 -63,26 -26,-5 -14,-49 -27,-49 -7,0 -32,62 -51,57 -20,-5 -49,-10 -49,-10l0 -165zm0 214c0,0 3,0 24,5 13,3 27,10 27,28 0,10 -4,29 3,33 7,3 12,-3 15,-5 63,-44 78,34 92,34 12,0 10,-54 27,-54 14,-5 144,56 144,95 0,8 -17,10 -19,18 -2,12 31,16 25,38 -2,13 -32,29 -24,38 9,8 49,-8 53,-8 8,0 10,13 10,18 0,72 -175,126 -214,110 -12,-5 -13,-41 -20,-41 -10,0 -15,33 -36,38 -20,3 -51,-21 -59,-15 -9,7 20,52 -36,52 -14,0 -14,-15 -14,-26l0 -357zm-465 -532c0,-226 347,-355 370,-469 26,23 29,60 29,93 0,137 -248,368 -248,535 0,18 2,23 2,34 0,16 -7,20 -10,20 -41,0 -143,-77 -143,-213zm-46 414c0,-26 21,-36 39,-36l301 0c37,0 53,11 53,49l1 501c0,16 -177,21 -183,10 -10,-16 -5,-44 -15,-44 -5,0 -32,39 -48,39 -15,0 -41,-28 -51,-28 -7,0 7,39 -7,56 -8,11 -90,20 -90,10l0 -556zm396 1228c0,34 -12,43 -42,36l-324 -62c-19,-3 -29,-15 -29,-34l0 -566c0,-15 53,-16 61,-10 15,13 10,61 20,61 14,0 49,-57 64,-57 32,0 54,18 61,15 7,-3 7,-29 15,-36 12,-8 48,-8 66,-10 31,-2 87,-7 87,-7 22,0 20,15 20,46l0 625z"
            />
            <path
                fill={fill1}
                d="M848 1245l139 0 -68 -430 -3 0 -68 430zm-55 371l-166 0 184 -1001 213 0 184 1001 -166 0 -31 -222 -188 0 -30 222z"
            />
            <polygon
                fill={fill1}
                points="1990,616 1990,1616 1841,1616 1841,835 1838,835 1683,1616 1599,1616 1444,835 1442,835 1442,1616 1292,1616 1292,616 1518,616 1640,1201 1642,1201 1764,616 "
            />
            <polygon
                fill={fill1}
                points="2122,1616 2122,616 2281,616 2491,1188 2493,1188 2493,616 2649,616 2649,1616 2499,1616 2280,991 2277,991 2277,1616 "
            />
            <polygon
                fill={fill1}
                points="2788,1616 2788,616 3249,616 3249,765 2960,765 2960,1023 3182,1023 3182,1173 2960,1173 2960,1467 3268,1467 3268,1616 "
            />
            <path
                fill={fill1}
                d="M3691 862c-7,-86 -53,-111 -92,-111 -55,0 -86,36 -86,98 0,170 349,252 349,524 0,165 -111,256 -272,256 -159,0 -251,-127 -258,-277l164 -24c7,101 47,151 103,151 60,0 100,-32 100,-92 0,-198 -349,-251 -349,-538 0,-159 97,-249 266,-249 140,0 223,101 238,243l-164 18z"
            />
            <polygon
                fill={fill1}
                points="4072,765 3905,765 3905,616 4410,616 4410,765 4243,765 4243,1616 4072,1616 "
            />
            <polygon
                fill={fill1}
                points="4832,1616 4661,1616 4661,1201 4453,616 4627,616 4748,997 4751,997 4866,616 5040,616 4832,1201 "
            />
            <polygon fill={fill1} points="630,2498 735,2498 735,1890 630,1890 " />
            <polygon
                fill={fill1}
                points="818,2498 818,1890 915,1890 1042,2238 1044,2238 1044,1890 1138,1890 1138,2498 1047,2498 914,2118 912,2118 912,2498 "
            />
            <polygon
                fill={fill1}
                points="1283,1981 1182,1981 1182,1890 1489,1890 1489,1981 1388,1981 1388,2498 1283,2498 "
            />
            <polygon
                fill={fill1}
                points="1546,2498 1546,1890 1826,1890 1826,1981 1651,1981 1651,2138 1786,2138 1786,2229 1651,2229 1651,2407 1838,2407 1838,2498 "
            />
            <path
                fill={fill1}
                d="M2014 2163l37 0c56,0 78,-21 78,-94 0,-73 -21,-94 -78,-94l-37 0 0 187zm0 335l-105 0 0 -609 147 0c117,0 177,50 177,180 0,98 -38,137 -73,153l88 276 -106 0 -74 -252c-13,2 -35,3 -54,3l0 249z"
            />
            <polygon
                fill={fill1}
                points="2310,2498 2310,1890 2407,1890 2534,2238 2536,2238 2536,1890 2630,1890 2630,2498 2539,2498 2406,2118 2404,2118 2404,2498 "
            />
            <path
                fill={fill1}
                d="M2809 2272l84 0 -41 -261 -2 0 -41 261zm-34 226l-101 0 112 -609 130 0 112 609 -101 0 -19 -135 -115 0 -19 135z"
            />
            <polygon
                fill={fill1}
                points="3137,1981 3035,1981 3035,1890 3342,1890 3342,1981 3241,1981 3241,2498 3137,2498 "
            />
            <polygon fill={fill1} points="3410,2498 3514,2498 3514,1890 3410,1890 " />
            <path
                fill={fill1}
                d="M3705 2348c0,46 13,67 56,67 42,0 56,-22 56,-67l0 -308c0,-46 -13,-67 -56,-67 -42,0 -56,22 -56,67l0 308zm-105 -311c0,-86 51,-156 160,-156 110,0 160,70 160,156l0 314c0,86 -51,156 -160,156 -110,0 -160,-70 -160,-156l0 -314z"
            />
            <polygon
                fill={fill1}
                points="3996,2498 3996,1890 4093,1890 4220,2238 4222,2238 4222,1890 4316,1890 4316,2498 4225,2498 4092,2118 4091,2118 4091,2498 "
            />
            <path
                fill={fill1}
                d="M4495 2272l84 0 -41 -261 -2 0 -41 261zm-34 226l-101 0 112 -609 130 0 112 609 -101 0 -19 -135 -115 0 -19 135z"
            />
            <polygon
                fill={fill1}
                points="4770,2498 4770,1890 4874,1890 4874,2407 5039,2407 5039,2498 "
            />
        </g>
    </svg>
);

AmnestyLogo.defaultProps = {
    fill0: '#EDE836',
    fill1: '#2F3031',
};

export default AmnestyLogo;
